import { HelpCircle, Brain, FileText, Code, BookOpen } from 'lucide-react';
import TabHub from '@/components/shared/TabHub';
import AITrainingDocs from '@/components/content/AITrainingDocs';
import DocumentsLibrary from '@/components/content/DocumentsLibrary';

const UserManualView = () => (
  <div style={{
    width: '100%',
    height: 'calc(100vh - 200px)',
    borderRadius: '12px',
    overflow: 'hidden',
    border: '1px solid #1e293b'
  }}>
    <iframe
      src="/help/user-manual.html"
      style={{ width: '100%', height: '100%', border: 'none' }}
      title="User Manual"
    />
  </div>
);

const FrameworkView = () => (
  <div style={{
    width: '100%',
    height: 'calc(100vh - 200px)',
    borderRadius: '12px',
    overflow: 'hidden',
    border: '1px solid #1e293b'
  }}>
    <iframe
      src="/help/ai-trading-framework.html"
      style={{ width: '100%', height: '100%', border: 'none' }}
      title="AI Trading Framework"
    />
  </div>
);

export default function HelpHub() {
  return (
    <TabHub
      title="Help & Education"
      subtitle="User manual, training docs, guides, and AI framework reference"
      icon={HelpCircle}
      accentColor="#22c55e"
      defaultTab="manual"
      tabs={[
        { id: 'manual', label: 'User Manual', icon: BookOpen, component: <UserManualView /> },
        { id: 'training', label: 'AI Training', icon: Brain, component: <AITrainingDocs theme="dark" /> },
        { id: 'docs', label: 'Documents', icon: FileText, component: <DocumentsLibrary /> },
        { id: 'framework', label: 'AI Framework', icon: Code, component: <FrameworkView /> },
      ]}
    />
  );
}
